// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_hf-0";
export var buttonContainer = "_hf-3";
export var cancelButton = "_hf-4";
export var headerSection = "_hf-6";
export var headerTitle = "_hf-9";
export var messageSideLeft = "_hf-1";
export var messageSideRight = "_hf-2";
export var orderNumberContainer = "_hf-7";
export var orderNumberLabel = "_hf-8";
export var submitButton = "_hf-5";